/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';
import productWarehouseTransformer from './productWarehouse';

export default class ProductBasicTransformer extends Transformer {

  static fetch(product) {
    return {
      id: product.id,
      name: product.name,
      price: product.price,
      qty: product.qty,
      taxId: product.tax_id,
      tax_perc: product.tax_perc,
      productDepositId: product.product_deposit_id,
      info: product.info,
      stockable: product.stockable,
      productTypeGroup: product.product_type_group,
      productType: product.product_type,
      warehouses: product.warehouses !== undefined ? productWarehouseTransformer.fetchCollection(product.warehouses) : [],
    };
  }

  static send(product) {
    return {
      id: product.id,
      name: product.name,
      price: product.price,
      tax_id: product.taxId,
      product_deposit_id: product.productDepositId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productBasic.js